/**
 * qbFormSection (qb-form-section) aims to implement a reusable binding container which facilitate access to reference values
 * and main functionalities and services available to different sections of the form without coupling each section to the parent
 * data structure.
 */
(function () {
	"use strict";

	angular.module("qbePortal").controller("FormSection", FormSection);

	FormSection.$inject = [
		"$scope",
		"$rootScope",
		"$state",
		"$sce",
		"$window",
		"quoteOptions",
		"quoteModelFactory",
		"labelService",
		"userInputRepository",
		"serviceResponseRepository",
		"paymentService",
		"Util",
		"$http",
		"$filter",
		"$location",
		"storage",
		"campaignService",
		"paymentLoggerService",
		"gtmService"
	];

	function FormSection(
		$scope,
		$rootScope,
		$state,
		$sce,
		$window,
		quoteOptions,
		quoteModelFactory,
		labelService,
		userInputRepository,
		serviceResponseRepository,
		paymentService,
		Util,
		$http,
		$filter,
		$location,
		storage,
		campaignService,
		paymentLoggerService,
		gtmService
	) {
		var vm = this;
		var userInputValues = {},
			children = {},
			sectionData = {};
		var errorCount = 0;
		var isRetrieval = storage.getItem("retrieve");
		$scope.hierarchyList = [$scope.name];
		vm.sectionName = $scope.name;
		vm.fieldValues = $scope.fieldValues || {};
		vm.formSelector = $scope.formSelector;
		vm.aggregatedListName = $scope.aggregatedListName;
		vm.fieldOptions = {};
		vm.children = children;
		vm.commonValues = {};
		vm.isEligible = false;
		vm.showError = false;
		vm.showPaypalError = false;
		vm.showAustpostBillpay = 0;
		vm.showSDExemption = storage.getItem("stamp-duty");
		vm.showCreditCard = false;
		vm.microformInstance = undefined;		

		vm.policyStartDateChanged = function(value) {
			if (!moment(value, "DD/MM/YYYY").isValid()) {
				return;
			}
			storage.setItem(
				'policy-start-date', 
				moment(
					value,
					"DD/MM/YYYY"
				).format("YYYY-MM-DD"));
			$rootScope.$broadcast("recall-get-details");
		};

		vm.toolTipHover = function(message) {
			gtmService.trackTooltipMouseOver(message);
		};

		function trackformErrorByErrorMessage(errMessage) {
			/* gtm track error message */
			if (errMessage) {
				gtmService.trackStandardEvent('error', 'error message', errMessage, true);
			}			
			/* end gtm track error message */
		}

		if (
			!isUndefinedOrNull($window.qbe.fieldLabels.config) &&
			!isUndefinedOrNull(
				$window.qbe.fieldLabels.config.AllowClaimsPayments
			)
		) {
			vm.showAustpostBillpay =
				$window.qbe.fieldLabels.config.AllowClaimsPayments;
		}

		if ($window.qbe.fieldLabels.validationSummary != undefined) {
			vm.formErrorMessage =
				$window.qbe.fieldLabels.validationSummary.formErrorMessage;

			if (vm.showError) {
				trackformErrorByErrorMessage(vm.formErrorMessage);
			}			
		}

		//unauthenticated payment
		vm.showPaymentSection = false;
		vm.isEnterPaymentRefError = false;
		vm.isEnterPaymentRefErrorLength = false;
		vm.policyCategory = "";
		vm.validateProducts = validateProducts;
		vm.selectProduct = selectProduct;

		vm.showContentsSumInsuredInLowerRange = false;
		vm.showYourContentsSumInsuredInLowerRange = false;
		vm.getBuildingEstimate = getBuildingEstimate;
		vm.getBuildingMaximum = getBuildingMaximum;
		vm.getBuildingMinimum = getBuildingMinimum;
		vm.getEstimateRebuild = getEstimateRebuild;
		vm.stateName = $state.$current.name;
		vm.validateBuildingSumInsured = validateBuildingSumInsured;
		vm.toggleContentsSumInsuredInLowerRange = toggleContentsSumInsuredInLowerRange;
		vm.toggleYourContentsSumInsuredInLowerRange = toggleYourContentsSumInsuredInLowerRange;
		vm.showAggregate = false;

		vm.csCCInvalid = false;
		vm.csCVCInvalid = false;

		$scope.$on("credit-card-number-isvalid", function (e, val) {
			vm.csCCInvalid = !val;
		});

		$scope.$on("credit-card-cvc-isvalid", function (e, val) {
			vm.csCVCInvalid = !val;
		});

		$scope.$on("bike-selected", function (e, val) {
			if (vm.fieldValues.insuredExcessValue){
				if (vm.fieldValues.insuredExcessValue.comprehensivePref === "agreed") {
					vm.fieldValues.insuredExcessValue.comprehensivePref = "market";
					vm.requote();
				}
			}			
		});
		//validate if quote is from retrieval to show driver aggregates
		if (angular.equals(isRetrieval, {})) vm.showAggregate = true;

		/*
		 * Polyfill for startswith for non supported browser
		 *
		 */
		if (!String.prototype.startsWith) {
			String.prototype.startsWith = function (searchString, position) {
				position = position || 0;
				return (
					this.substr(position, searchString.length) === searchString
				);
			};
		}

		//Fill in old details if returned from Paypal
		function restoreDetails() {
			var formDetails = storage.getItem("userInput");

			vm.fieldValues.selectInsuranceType =
				formDetails.paybillForm.selectInsuranceType.selectInsuranceType;
			validateProducts(vm.fieldValues.selectInsuranceType);
			vm.fieldValues.enterPaymentRef =
				formDetails.paybillForm.selectInsuranceType.enterPaymentRef;
			storage.setItem("auto-find-bill", {
				trigger: true,
			});
		}

		if ($window.qbe.fieldLabels != undefined) {
			vm.sessionLabels = $window.qbe.fieldLabels.sessionFunction;
		}

		$scope.$on("restore-payment-details", function () {
			restoreDetails();
		});

		$scope.$on("clear-field-values", function () {
			storage.clear();
			$scope.formData = {};
		});

		$scope.$root.$on("common-value-update", function (event, update) {
			vm.commonValues[update.name] = update.value;
		});

		$scope.$on("switch-to-QBE", function (event, isEligible) {
			vm.isEligible = isEligible;
		});

		//show amount on top right payments pag
		$scope.$on("switch-payment-amount", function (
			event,
			showPaymentSection
		) {
			vm.showPaymentSection = showPaymentSection;
		});

		$scope.$on("show-aggregate", function () {
			vm.showAggregate = true;
		});

		/** Event received from child sections to receive common values upon initialisation
		 * This is for cases when sections requiring common values are registered after those providing them
		 */
		$scope.$on("request-common-values", function (event, update) {
			$scope.$broadcast("received-common-values", vm.commonValues);
		});

		/** updates common values upon receiving from parent section */
		$scope.$on("received-common-values", function (event, commonValues) {
			vm.commonValues = commonValues;
		});

		$scope.$on("broadcast-field-errors", function (event) {
			vm.showError = true;
			vm.showPaypalError = false;
			vm.formErrorMessage =
				$window.qbe.fieldLabels.validationSummary == undefined
					? null
					: $window.qbe.fieldLabels.validationSummary
							.formErrorMessage;
			trackformErrorByErrorMessage(vm.formErrorMessage);
		});

		$scope.$on("broadcast-no-field-errors", function (event) {
			vm.showError = false;
			vm.showPaypalError = false;
		});

		$scope.$on("paypal-payment-error", function (event) {
			vm.showPaypalError = true;
			vm.formErrorMessage =
				$window.qbe.fieldLabels.paypalCodeMessage.value;
			trackformErrorByErrorMessage(vm.formErrorMessage);
		});

		$scope.$on("payment-already-made", function (event) {
			vm.showError = true;
			vm.showPaypalError = false;
			vm.formErrorMessage =
				$window.qbe.fieldLabels.validationSummary.alreadyPaidMessage;
			trackformErrorByErrorMessage(vm.formErrorMessage);
		});

		$scope.$on("payment-error", function (event) {
			vm.showError = true;
			vm.showPaypalError = false;
			vm.formErrorMessage =
				$window.qbe.fieldLabels.validationSummary.paymentErrorMessage;
			trackformErrorByErrorMessage(vm.formErrorMessage);
		});

		$scope.$on("invalid-payment-reference-number", function (event) {
			vm.showError = true;
			vm.showPaypalError = false;
			if ($window.qbe.fieldLabels.paymentRefNoMatchFound) {
				vm.formErrorMessage =
				$window.qbe.fieldLabels.paymentRefNoMatchFound.pleaseCheckRefNumber;
				trackformErrorByErrorMessage(vm.formErrorMessage);
			}
		});

		$scope.$on("direct-debit-payment-error", function (event) {
			vm.showError = true;
			vm.showPaypalError = false;
			vm.formErrorMessage =
				$window.qbe.fieldLabels.directDebitMessage.value;
			trackformErrorByErrorMessage(vm.formErrorMessage);
		});

		// $scope.$on('credit-card-form-error', function (event) {
		// 	vm.showError = true;
		// 	vm.showPaypalError = false;
		// 	vm.formErrorMessage = $window.qbe.fieldLabels.validationSummary.formErrorMessage;
		// });
		/**
		 * Holds all the reference values to be used by the form section to access
		 * other values entered by the user in other steps of the form.
		 */
		vm.quoteModel = quoteModelFactory.create();

		$scope.$root.$on("selected-quote-changed", function () {
			vm.quoteModel = quoteModelFactory.create();
		});

		// Check the return of campaign code validation
		$scope.$on("valid-campaign", function (event, args) {
			if (args.isValid) {
				vm.campaignBanner = campaignService.getCampaignConfig(
					args.promoValue,
					false
				).content;
				vm.isCampaignCodeValid = campaignService.getCampaignConfig(
					args.promoValue,
					false
				).isCampaignCodeValid;
			} else {
				vm.isCampaignCodeValid = false;
			}
		});

		$scope.$root.$on("update-quote-model-reference", function () {
			vm.quoteModel = quoteModelFactory.create();
		});
		/**
		 * Creates an Array and assigns it to the fieldValues with the given name @fieldName
		 */
		vm.initialiseListFor = function (fieldName) {
			if (
				!vm.fieldValues[fieldName] ||
				!Array.isArray(vm.fieldValues[fieldName])
			)
				vm.fieldValues[fieldName] = [];
		};

		/**
		 * Creates an object {} and assings it to the fieldValues with given name @fieldName
		 */
		vm.initialiseFieldValue = function (formObjectName) {
			if (!vm.fieldValues[formObjectName]) {
				vm.fieldValues[formObjectName] = {};
			}
		};

		/**
		 * Gets the list of options from labelService for the fieldName provided @fieldName
		 * optionally adds @defaultValue to the list.
		 */
		vm.getOptionsFor = function (fieldName, defaultValue) {
			return getOptions(fieldName, defaultValue);
		};

		vm.disableNext = function (disable) {
			$scope.$emit("disable-next", disable);
		};

		vm.disableNextForConvictions = function (key, value, section) {
			$scope.$emit("conviction-check", {
				conviction: key,
				input: value,
				section: section,
			});
		};

		function getOptions(fieldName, defaultValue) {
			if (!vm.fieldOptions[fieldName]) {
				vm.fieldOptions[fieldName] = labelService
					.getOptionsFor(fieldName)
					.slice();
				if (defaultValue)
					vm.fieldOptions[fieldName].unshift(defaultValue);
			}

			return vm.fieldOptions[fieldName];
		}

		// TODO: set campaign code for ctp sa
		vm.getCtpBanner = function () {
			var codeFromLink = userInputRepository.get(
				{},
				"ctpForm.promotionalCode.value"
			);

			if (!isUndefinedOrNull(codeFromLink)) {
				vm.campaignBanner = campaignService.getCampaignConfig(
					codeFromLink,
					false
				).content;
				if (isUndefinedOrNull(vm.campaignBanner)) {
					return false;
				} else return true;
			}
		};

		vm.getCampaignSteps = function (text) {
			return $sce.trustAsHtml(text);
		};

		vm.getObjectValue = function (fieldName, fieldLabel) {
			return $sce.trustAsHtml(
				labelService.getObjectValue(fieldName, fieldLabel)
			);
		};

		vm.getObjectValueRaw = function (fieldName, fieldLabel) {
			return labelService.getObjectValue(fieldName, fieldLabel);
		};

		vm.getLabelFor = function (fieldName) {
			return $sce.trustAsHtml(labelService.getLabelFor(fieldName));
		};

		vm.getSectionLabelFor = function (fieldName) {
			return $sce.trustAsHtml(labelService.getSectionLabelFor(fieldName));
		};

		vm.getSectionDescriptionFor = function (fieldName) {
			return $sce.trustAsHtml(
				labelService.getSectionDescriptionFor(fieldName)
			);
		};

		vm.getHintTextFor = function (fieldName) {
			return $sce.trustAsHtml(labelService.getHintTextFor(fieldName));
		};

		vm.getHelpTextFor = function (fieldName) {
			return $sce.trustAsHtml(labelService.getHelpTextFor(fieldName));
		};

		vm.getGlobalOptionsFor = function (optionType, defaultValue) {
			var options = labelService.getGlobalOptionsFor(optionType).slice();
			if (defaultValue) {
				options.unshift(defaultValue);
			}

			return options;
		};

		vm.getGlobalOptionLabel = function (optionType, optionValue) {
			var optionKeyValues = this.getGlobalOptionsFor(optionType);
			var label = null;
			if (optionKeyValues) {
				angular.forEach(optionKeyValues, function (option) {
					if (option.value == optionValue) label = option.label;
				});
			}

			return label;
		};

		/**
		 * Gets content-authored option names from the label service for options returned by the service.
		 * This allows content-authors to define labels for values returned by GuideWire services for example.
		 */
		vm.getLabelForRemoteOption = function (fieldName, labelKey) {
			return labelService.getLabelForRemoteOption(fieldName, labelKey);
		};

		vm.hasServiceResponseFrom = function (serviceName) {
			//call getUserInput method in form.controller to have a session storage
			$scope.$root.$broadcast("get-user-input");
			QBE.expandCollapse.init();
			return (
				serviceResponseRepository.getLastResponseFrom(serviceName) !==
				null
			);
		};

		vm.setCoverTypeClass = function (coverTypeClass) {
			vm.setSelectedCoverType(coverTypeClass, "standard");
		};

		vm.setCoverTypeClassWithMotorSubClass = function (
			coverTypeClass,
			comprehensiveCoverTypeSubClass,
			thirdPartyCoverTypeSubClass
		) {
			if (coverTypeClass === "comprehensive") {
				//comprehensive set to standard
				vm.setSelectedCoverType(coverTypeClass, "standard");
			} else if (coverTypeClass === "third_party") {
				if (thirdPartyCoverTypeSubClass === "third_party") {
					//production issue fix [CPJIRA-4147] as default 3rd party is standard
					thirdPartyCoverTypeSubClass = "standard";
				}
				vm.setSelectedCoverType(
					coverTypeClass,
					thirdPartyCoverTypeSubClass
				);
			} else {
				//else do a standard subclass
				vm.setSelectedCoverType(coverTypeClass, "standard");
			}
		};

		vm.setCoverTypeSubClass = function (coverTypeSubClass) {
			var coverType = quoteOptions.getSelectedCoverType();
			vm.setSelectedCoverType(coverType.superType, coverTypeSubClass);
		};

		vm.setSelectedCoverType = function (coverTypeClass, coverTypeSubClass) {
			quoteOptions.setSelectedCoverType(
				coverTypeClass,
				coverTypeSubClass
			);
			vm.requote();
			// $scope.$root.$broadcast('selected-quote-changed') ;
		};

		vm.setSelectedOffering = function (offering) {
			quoteOptions.setSelectedOffering(offering);
			vm.requote();
			// $scope.$root.$broadcast('selected-quote-changed') ;
		};

		/*
		 *calculates the claimable rent
		 * weeks - in format '4Weeks'...'15Weeks'
		 */
		vm.getRentClaimValue = function (weeklyRent, weeks) {
			return parseInt(weeks) * weeklyRent;
		};

		vm.isSumInsuredTypeAvailable = function (insuredType) {
			return quoteOptions.isSumInsuredTypeAvailable(insuredType);
		};

		vm.isCoverTypeAvailable = function (coverTypeClass) {
			return quoteOptions.isCoverTypeAvailable(coverTypeClass);
		};

		vm.isCoverSubTypeAvailable = function (
			coverTypeClass,
			coverTypeSubClass
		) {
			return quoteOptions.isCoverSubTypeAvailable(
				coverTypeClass,
				coverTypeSubClass
			);
		};

		vm.getSelectedCoverType = function () {
			return quoteOptions.getSelectedCoverType();
		};

		vm.getSelectedQuote = function () {
			return quoteOptions.getSelectedQuoteResponse();
		};

		vm.getQuickQuoteData = function () {
			return serviceResponseRepository.getLastResponseFrom("quickQuote");
		};

		vm.isStrataOrRegisteredVisible = function () {
			var buildingType = userInputRepository.get(
				{},
				"homeForm.tellUsAboutTheProperty.typeOfBuilding"
			);
			var state = userInputRepository.get(
				{},
				"homeForm.tellUsAboutTheProperty.address.state"
			);
			var includedTypes = [
				"unit",
				"duplex",
				"triplex",
				"flat",
				"villa",
				"townhouse",
			];
			if (state === "AU_WA" && includedTypes.indexOf(buildingType) > -1) {
				return true;
			} else {
				return false;
			}
		};

		vm.getAddressState = function () {
			var state = userInputRepository.get(
				{},
				"homeForm.tellUsAboutTheProperty.address.state"
			);
			return state;
		};

		vm.isRapidEstimatePanelVisible = function () {
			var visible = true;
			if (vm.sectionName === "homeForm") {
				var howIsHomeOccupied = vm.commonValues.howIsHomeOccupied;
				if (howIsHomeOccupied === "unoccupied") {
					visible = false;
				}

				if (
					vm.commonValues.coverNeeds_contents == true ||
					vm.commonValues.coverNeeds_building == true
				) {
				} else {
					visible = false;
				}
			}

			return visible;
		};

		vm.isDisplayRapidEstimate = function () {
			var display = false;
			if ($window.qbe.rapidEstimateDisplay) {
				if ($window.qbe.rapidEstimateDisplay.display == true) {
					display = true;
				} else {
					display = false;
				}
			}
			return display;
		};
		vm.$onInit = function () {
			if ($scope.register)
				// gtm track landing page
				if ($scope.name === 'paybillForm') {
					gtmService.trackPayBillVirtualPageLanding();
				}
				$scope.register({
					name: $scope.name,
					init: vm.initFn,
					get: vm.getValue,
				});

			if ($scope.formData) {
				//sets it back to the formsection as the object has not been fully initialised when called in form controller
				Util.dispatchCustomEvent("register-labels");
				vm.fieldValues = $scope.formData[$scope.name] || {};
			}

			if (vm.sectionName == "yourBuilding") {
				//dd-3747 - added building sum insured checking because radio buttons are not in the data model
				checkBuildingSumInsured();
			}

			if (vm.sectionName == "mainPolicyHolderContact") {
				vm.fieldValues.emailAddress1 = vm.quoteModel.email;
			}

			if (vm.sectionName == "selectInsuranceType") {
				var paymentError = storage.getItem("payment-error-details");
				if (paymentError && paymentError.mode == "paypal") {
					$scope.$broadcast("paypal-payment-error");
					restoreDetails();
					storage.removeItem("payment-error-details");
				}

				if (paymentError && paymentError.mode == "cc") {
					$scope.$broadcast("payment-error");
					restoreDetails();
					storage.removeItem("payment-error-details");
				}				

				// open section according to param
				var uiSelectedInsuranceType = '';
				var uiSelectedInsuranceTypeCode = $location.search().t;
				var uiRefNum =  $location.search().r;

				var selectedInsuranceTypeOptions = vm.getOptionsFor('selectInsuranceType');

				if (uiSelectedInsuranceTypeCode) {
					uiSelectedInsuranceTypeCode = uiSelectedInsuranceTypeCode.toLowerCase();

					if (selectedInsuranceTypeOptions && selectedInsuranceTypeOptions.length > 0) {
						for (var n = 0; n < selectedInsuranceTypeOptions.length; n++) {
							var selectedInsuranceTypeItem = selectedInsuranceTypeOptions[n];
							if (selectedInsuranceTypeItem.attributes != "" && selectedInsuranceTypeItem.attributes == uiSelectedInsuranceTypeCode) {
								uiSelectedInsuranceType = selectedInsuranceTypeItem.value;
								break;
							}
						}
					}
				}
				
				if (uiSelectedInsuranceType) {
					vm.fieldValues.selectInsuranceType = uiSelectedInsuranceType;
					vm.selectProduct(vm.fieldValues.selectInsuranceType);
				}				

				if (uiRefNum) {
					vm.fieldValues.enterPaymentRef = uiRefNum;
				}

				// // perform search
				if (vm.fieldValues.selectInsuranceType && vm.fieldValues.enterPaymentRef) {
					setTimeout(function (){
						var findBillButton = document.getElementById("find-bill");
						if (findBillButton) {
							findBillButton.click();
						}
					}, 500);
				}				
			}

			// Check if campaign code is valid
			if (vm.quoteModel && vm.quoteModel.quoteResult) {
				var quoteResponse = vm.quoteModel.quoteResult.response;
				if (
					quoteResponse.isCampaignCodeValid ||
					quoteResponse.isGiftCardApplied
				) {
					vm.campaignBanner = campaignService.getCampaignConfig(
						quoteResponse.campaignCode,
						false
					).content;
					vm.isCampaignCodeValid = campaignService.getCampaignConfig(
						quoteResponse.campaignCode,
						false
					).isCampaignCodeValid;
				} else {
					vm.isCampaignCodeValid = false;
				}
			}

			if (vm.quoteModel && !vm.quoteModel.policyStartDate) {
				storage.setItem('policy-start-date', moment().tz("Australia/Sydney").format("YYYY-MM-DD"));
			}
		};

		/**
		 * Registers child form sections with the current form section.
		 * Similar to registerSection in form controller, it keeps track of child sections, their value and
		 * initialisation.
		 */
		vm.registerFormField = function (childName, initValueFn, getValueFn) {
			if (!children[childName]) children[childName] = {};
			children[childName].initValueFn = initValueFn;
			children[childName].getValueFn = getValueFn;
			$scope.$emit("request-common-values");
			if (vm.fieldValues && vm.fieldValues[childName]) {
				initValueFn(vm.fieldValues[childName]);
			}
		};

		vm.registerIdGenerator = function (childName, initIdFn) {
			if (!children[childName]) children[childName] = {};

			children[childName].initIdFn = initIdFn;
			initIdFn($scope.name);
		};

		/**
		 * keep track of the hierarchy of form sections and is used to generate automatic, unique HTML IDs.
		 */
		vm.registerHierarchy = function (childName, setHierarchyFn) {
			if (!children[childName]) children[childName] = {};
			children[childName].setHierarchyFn = setHierarchyFn;
			setHierarchyFn($scope.hierarchyList);
		};

		/**
		 * @return the value of all child form sections as well as all direct inputs of the current section.
		 */
		vm.getValue = function () {
			for (var key in children) {
				if (children[key].getValueFn) {
					if (vm.aggregatedListName)
						vm.fieldValues[vm.aggregatedListName][
							parseInt(key)
						] = children[key].getValueFn();
					else vm.fieldValues[key] = children[key].getValueFn();
				}
			}

			return vm.fieldValues;
		};

		vm.resetInsuredExcessValue = function() {
			var test = vm.fieldValues;
		}

		/**
		 * Callback used by components to update their value and pass it back to the parent form section.
		 */
		vm.updateComponentValue = function (name, value) {
			vm.fieldValues[name] = value;
		};

		vm.removeSection = function (aggregator) {
			var childSectionsToRemove = [];
			for (var key in vm.children) {
				var childSection = vm.children[key],
					childValue = childSection.getValueFn();
				if (childValue._aggregator == aggregator) {
					childSectionsToRemove.push(key);
				}
			}
			childSectionsToRemove.forEach(function (sectionKey) {
				delete vm.children[sectionKey];
			});
		};

		/**
		 * Initialises the form section and all its child sections.
		 */
		vm.initFn = function (data, parentName) {
			vm.fieldValues = data;
			// for (var key in children) {
			// 	child.setParent()
			// 	var child = children[key] ;
			// 	if ( child.initIdFn ) child.initIdFn(parentName);
			// 	if ( child.setHierarchyFn ) child.setHierarchyFn(parentName);
			// };
		};

		vm.getAge = function (dob) {
			return Math.floor(
				moment(new Date()).diff(
					moment(dob, "DD/MM/YYYY"),
					"years",
					true
				)
			);
		};

		vm.getCeilingAge = function (dob, floatPoint) {
			return Math.ceil(
				moment(new Date()).diff(
					moment(dob, "DD/MM/YYYY"),
					"years",
					true
				)
			);
		};

		vm.getAgeInDays = function (dob) {
			return Math.floor(
				moment(new Date()).diff(moment(dob, "DD/MM/YYYY"), "days", true)
			);
		};

		vm.getPastYears = function (numYears) {
			if (!vm.fieldOptions["years_" + numYears]) {
				var years = [];
				var prevYear = "";
				for (var i = 0; i < numYears; i++) {
					prevYear = moment().subtract(i, "year").format("Y");
					years.push({
						label: prevYear,
						value: prevYear,
					});
				}
				vm.fieldOptions["years_" + numYears] = years;
			}
			return vm.fieldOptions["years_" + numYears];
		};

		vm.getPastYearsFrom = function (year) {
			var currentYear = parseInt(moment().format("Y"));
			return vm.getPastYears(currentYear - (year - 1));
		};

		vm.payByPaypal = function () {
			$scope.$root.$broadcast("loading-animation-start");

			paymentService.payByPaypal(
				// on successfully calling the Create Paypal Payment service
				function (redirectUrl) {
					paymentLoggerService.trackQuoteStatus(
						"redirecting to paypal",
						"waiting for Paypal callback"
					);
					$window.location.href = redirectUrl;
				},
				// on error
				function (errorResponse) {
					paymentLoggerService.trackQuoteStatus(
						"cannot connect to paypal",
						null,
						errorResponse
					);
					console.error(errorResponse);
				}
			);
		};

		vm.requote = function (form, isRequoteBlocked) {
			if (isRequoteBlocked === true) {
				//to do additional checking for requote, if set to true requote is not done
			} else {
				$scope.$root.$broadcast("requote", form);
			}
		};

		vm.setMainPolicyHolderEmail = function (email) {
			userInputRepository.update({
				email: email,
			});
		};

		vm.onPaymentFrequencyChanged = function (paymentFrequency) {
			$scope.$root.$broadcast("update-payment-options", paymentFrequency);
			quoteOptions.setSelectedPaymentFrequency(paymentFrequency);
			vm.updatePaymentSummary(paymentFrequency);
			vm.updatePaymentStartDate(paymentFrequency);
		};

		/**
		 * vm.updatePaymentStartDate - Update payment start date
		 * @param {string} data selected payment option
		 */
		vm.updatePaymentStartDate = function (data) {
			if (data === "monthly" || data === "fortnightly") {
				vm.fieldValues.paymentStartDate = moment(
					vm.quoteModel.policyStartDate,
					"DDMMYYYY"
				).format("DD/MM/YYYY");
			}
		};

		vm.getRange = function (data) {
			if (
				moment(vm.quoteModel.policyStartDate, "DDMMYYYY").format(
					"DDMMYYYY"
				) === moment().tz("Australia/Sydney").format("DDMMYYYY")
			) {
				return "0d:14d";
			}
			var sDate =
				moment(vm.quoteModel.policyStartDate, "DDMMYYYY").diff(
					moment(),
					"days"
				) + 1;
			var eDate =
				parseInt(
					moment(vm.quoteModel.policyStartDate, "DDMMYYYY").diff(
						moment(),
						"days"
					) + 1
				) + parseInt(data);
			return sDate + "d:" + eDate + "d";
		};

		/**
		 * vm.updatePaymentSummary - Update payment summary
		 *
		 * @param {string} data selected payment option
		 */
		vm.updatePaymentSummary = function (data) {
			if (data == "yearly") {
				//yearly frequency should not allow bankaccount
				if (vm.fieldValues.paymentMethod == "bankaccount") {
					//sets credit card as the default option
					vm.fieldValues.paymentMethod = "creditcard";
					$scope.$root.$broadcast(
						"payment-method-changed",
						"creditcard"
					);
				}
			} else {
				//any frequency other than yearly should not allow paypal
				if (vm.fieldValues.paymentMethod == "paypal") {
					//sets credit card as the default option
					vm.fieldValues.paymentMethod = "creditcard";
					$scope.$root.$broadcast(
						"payment-method-changed",
						"creditcard"
					);
				}
			}
		};

		vm.paymentMethodChanged = function (paymentMethod) {
			$scope.$root.$broadcast("payment-method-changed", paymentMethod);
			console.log("paymentMethod", paymentMethod);
		};

		vm.termsAndConditionsChanged = function (termsAndConditions) {
			$scope.$root.$broadcast(
				"terms-and-conditions-changed",
				termsAndConditions ? true : false
			);
			console.log("termsAndConditions", termsAndConditions);
		};

		vm.noItemIsChecked = function (list) {
			if (Object.keys(list)) {
				for (var key in list) {
					if (list[key] == true) return false;
				}
			}
			return true;
		};

		vm.numberOfItemsChecked = function (list) {
			var counter = 0;
			angular.forEach(list, function (value) {
				if (value === true) counter++;
			});
			return counter;
		};

		vm.refreshPolicy = function (paymentType) {
			vm.showCreditCard = false;
			//option choose credit card
			if (paymentType === 'credit-card') {	
				vm.showError = false;	
				vm.showCreditCard = true;
				
				var hostOrigin = $window.location.origin;
				
				//get concig
				var paymentConfig = paymentService.getPaybillConfig()
				if (!paymentConfig) {
					errorDuringTokenization();						
				}
				else {
					paymentService.initialCreditcardPayment(
						paymentConfig.mulesoftFlexiMicroformApiUrl,
						hostOrigin, 
						paymentService.generateUniqueId(),
						paymentConfig.merchantIdentifier,
						paymentConfig.clientId,
						paymentConfig.clientSecret,
						initialCreditcardPaymentSuccessCallback,
						initialCreditcardPaymentFailCallback);
				}				
			}
			if (vm.sectionName == "getStartedCtp")
				$scope.$emit(
					"set-has-personOrCompany",
					vm.fieldValues.personOrCompany == "no"
				);
			else if (vm.sectionName == "selectInsuranceType") {
				/* track payment details to gtm */
				$scope.$root.$broadcast('trackPaymentDetailsPaymentType', vm.fieldValues.howToPay);
				/* end track payment details to gtm */
			}
			
			//console.log('invalidting quick quote responses');
			$scope.$emit("invalidate-quotes");
		};
		function initialCreditcardPaymentSuccessCallback(jwk) {
			vm.showCreditCard = true;

			// cybersourceService
			FLEX.microform(
				paymentService.getKeyData(
					jwk, 
					'#cardNumber-container', 
					'#cardNumber-label',
					''),
				function (setupError, microformInstance) {
					if (setupError) {
						// handle error
						errorDuringTokenization();
						return;
					}

					$rootScope.$broadcast("set-micoform-instance", microformInstance);
				}
			);
		}

		function initialCreditcardPaymentFailCallback(error) {			
			errorDuringTokenization();
		}

		function errorDuringTokenization(message) {
			vm.showCreditCard = false;
			vm.showError = true;
			vm.showPaypalError = false;
			errorCount++;

			vm.formErrorMessage = 'Credit card service is not available at the moment. Please try again later.';

			scrollViewTo($("#content"));
		}

		vm.getOptionsForBuildingYearBuilt = function (fieldName) {
			if (!vm.fieldOptions[fieldName]) {
				var options = vm.getGlobalOptionsFor(fieldName);
				for (var i = 2000; i <= new Date().getFullYear(); i++) {
					options.unshift({
						label: String(i),
						value: String(i),
					});
				}
				vm.fieldOptions[fieldName] = options;
				return options;
			} else return vm.fieldOptions[fieldName];
		};

		/*
		 * TO BE MOVED TO HOME QUOTE MODEL
		 *
		 * Checks if the provided cover need is available for the options selected on page
		 */
		vm.isHomeCoverNeedAvailable = function (coverNeed) {
			var typeOfBuilding = "";
			var isPropertyProfessionalAgent = false;
			var howIsHomeOccupied = "";

			if (vm.commonValues.typeOfBuilding) {
				typeOfBuilding = vm.commonValues.typeOfBuilding;
			}

			if (vm.commonValues.propertyProfessionalAgent !== undefined) {
				isPropertyProfessionalAgent =
					vm.commonValues.propertyProfessionalAgent;
			} else if (
				!!vm.quoteModel.homeForm &&
				!!vm.quoteModel.homeForm.tellUsAboutTheProperty
					.propertyProfessionalAgent
			) {
				isPropertyProfessionalAgent =
					vm.quoteModel.homeForm.tellUsAboutTheProperty
						.propertyProfessionalAgent;
			}

			if (vm.commonValues.howIsHomeOccupied) {
				howIsHomeOccupied = vm.commonValues.howIsHomeOccupied;
			}

			if (coverNeed === "contents") {
				return true;
			} else if (coverNeed === "building") {
				//dont show building if rent and live
				if (howIsHomeOccupied === "rent_live") {
					return false;
				}

				if (typeOfBuilding === "unit" || typeOfBuilding === "flat") {
					return false;
				} else {
					return true;
				}
			} else if (coverNeed === "rent_default") {
				if (
					isPropertyProfessionalAgent === true &&
					howIsHomeOccupied === "own_rent_tenants"
				) {
					return false;
				} else {
					return false;
				}
			} else if (coverNeed === "malicious_damage") {
				if (
					isPropertyProfessionalAgent === true &&
					howIsHomeOccupied === "own_rent_tenants"
				) {
					return true;
				} else {
					return false;
				}
			}
			return true;
		};

		vm.yearHomeBuilt = function () {
			var cycloneRating = vm.getObjectValueRaw("cycloneRating", "value");
			var cycloneParams = [
				userInputRepository.get(
					{},
					"homeForm.tellUsAboutTheBuilding.yearHomeBuilt"
				),
				parseInt(cycloneRating),
			];
			return cycloneParams;
		};

		// Show/Hide of Payment Failure - Credit Card error message
		$scope.$on("cyber-source-error", function (event, code) {
			validateCybersourceError(code);
		});

		function validateCybersourceError(data) {
			var cybersourceList =
				$window.qbe.fieldLabels.cybersourceCodeMessage.cybersourceError;
			if (!isUndefinedOrNull(data)) {
				vm.showError = true;
				vm.showPaypalError = false;
				errorCount++;

				if (typeof cybersourceList[data] !== "undefined") {
					vm.formErrorMessage = cybersourceList[data];
				} else {
					vm.formErrorMessage = cybersourceList["default"];
				}
				trackformErrorByErrorMessage(vm.formErrorMessage);

				scrollViewTo($("#content"));
			} else {
				vm.showError = false;
			}
		}

		function splitKeyInValidation(key) {
			key.split(",");
		}

		/**
		 * Scrolls to the field element
		 */
		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left,
				});
			}
		}
		//return options to the needs checkbox
		vm.getOptionsForCoverNeeds = function (fieldName) {
			var options = getOptions(fieldName).slice();
			var returnOptions = [];
			for (var item in options) {
				if (vm.isHomeCoverNeedAvailable(options[item].value)) {
					returnOptions.push(options[item]);
				} else {
					vm.commonValues[
						"coverNeeds_" + options[item].value
					] = false;
				}
			}
			return returnOptions;
		};

		vm.showNeedsCoverOutsideHome = function () {
			var show =
				!!vm.commonValues.coverNeeds_contents &&
				[
					"own_live",
					"rent_live",
					"unoccupied",
					"own_holidayhome",
				].indexOf(vm.commonValues.howIsHomeOccupied) != -1;
			// update the form value
			vm.commonValues.needCoverOutsideHome =
				vm.fieldValues.needCoverOutsideHome;

			return show;
		};

		//methods for home
		vm.submitRapidEstimate = function (form, isNavigatingForward) {
			$scope.$root.$broadcast("home-rapid-estimate", form);
		};

		/**
		 *    Set default selected payment option
		 */
		vm.paymentOptions = "yearly";
		vm.updatePaymentSummary("yearly");

		vm.moveToPage = function (page) {
			$scope.$root.$broadcast("moveToPage", page);
		};

		$scope.$on("confirm-form-data", function (event, formData) {
			if (
				vm.sectionName == "nearCompleteCtp" ||
				vm.sectionName == "paybillForm"
			) {
				vm.fieldValues.firstName =
					formData.vehicleFormCtp.registeredOwnerCtp.firstName;
				vm.fieldValues.surName =
					formData.vehicleFormCtp.registeredOwnerCtp.surName;
				var bDate =
					formData.vehicleFormCtp.registeredOwnerCtp.birthDate;
				vm.fieldValues.birthDate = bDate; //bDate.substr(0, 2) + "/" + bDate.substr(3,2) + "/" + bDate.substr(6,4);
				vm.fieldValues.regEmail =
					formData.vehicleFormCtp.registeredOwnerCtp.regEmail;
				vm.fieldValues.regMobileNum =
					formData.vehicleFormCtp.registeredOwnerCtp.regMobileNum;
				vm.fieldValues.regPostCode =
					formData.vehicleFormCtp.registeredOwnerCtp.regPostCode;

				//about your card
				var regDate =
					formData.vehicleFormCtp.aboutYourCarCtp.registrationDueDate;
				vm.fieldValues.registrationDueDate = regDate; //regDate.substr(0, 2) + "/" + regDate.substr(3,2) + "/" + regDate.substr(6,4);
				vm.fieldValues.driverLicenseNum =
					formData.vehicleFormCtp.aboutYourCarCtp.driverLicenseNum;
				vm.fieldValues.vehicleRegNum =
					formData.vehicleFormCtp.aboutYourCarCtp.vehicleRegNum;
				vm.fieldValues.vehicleType =
					formData.vehicleFormCtp.aboutYourCarCtp.vehicleType;
				vm.fieldValues.insurancePeriod =
					formData.vehicleFormCtp.insurancePeriodCtp.insurancePeriod;
			}
		});

		$scope.$watch("vm.fieldValues.enterPaymentRef", function () {
			vm.showPaymentSection = false;
			vm.isEnterPaymentRefError = false;
			vm.isEnterPaymentRefErrorLength = false;
		});

		$scope.$watch("vm.fieldValues.birthDay", function (value) {
			validateBirthDate();
		});

		$scope.$watch("vm.fieldValues.birthMonth", function (value) {
			validateBirthDate();
		});

		$scope.$watch("vm.fieldValues.birthYear", function (value) {
			validateBirthDate();
		});

		$scope.$watch("vm.fieldValues.birthDate", function (value) {
			if (vm.sectionName == "registeredOwnerCtp" && value.length >= 8) {
				vm.formSelector.birthDate.$setValidity("age", true);
				var isValid = isDate(vm.fieldValues.birthDate);
				var parent = angular.element(
					document.querySelector("[field-key='birthDate']")
				);
				if (!isValid) {
					parent.addClass("is-error");
					vm.formSelector.birthDate.$setValidity("date", false);
					vm.formSelector.birthDate.$setValidity("age", true);
				} else {
					parent.removeClass("is-error");
					vm.formSelector.birthDate.$setValidity("date", true);
					var birthDate = new Date(
						vm.fieldValues.birthYear,
						vm.fieldValues.birthMonth - 1,
						vm.fieldValues.birthDay
					);
					var age = getYearDiff(birthDate, Date.now());
					if (age >= 16) {
						vm.formSelector.birthDate.$setValidity("age", true);
						parent.removeClass("is-error");
					} else {
						vm.formSelector.birthDate.$setValidity("age", false);
						parent.addClass("is-error");
					}
				}
			}
		});

		$scope.$watch("vm.fieldValues.regDueDay", function (value) {
			validateRegistrationDueDate();
		});

		$scope.$watch("vm.fieldValues.regDueMonth", function (value) {
			validateRegistrationDueDate();
		});

		$scope.$watch("vm.fieldValues.regDueYear", function (value) {
			validateRegistrationDueDate();
		});

		$scope.$watch("vm.fieldValues.regPostCode", function (value) {
			validatePostCode();
		});

		// $scope.$watch('vm.fieldValues.enterPaymentRef', function (value) {
		// 	vm.showError = false;
		// 	if (value) {
		// 		validatePaymentRefNum();
		// 		searchForRefNum();
		// 	} else {
		// 		$scope.$emit('billUpdate');
		// 		$scope.$emit('toggle-amount-due');
		// 	}
		// });

		$scope.$watch("vm.fieldValues.registrationDueDate", function (value) {
			if (vm.sectionName == "aboutYourCarCtp" && value.length >= 8) {
				var isValid = isDate(vm.fieldValues.registrationDueDate);
				var parent = angular.element(
					document.querySelector("[field-key='registrationDueDate']")
				);
				if (!isValid) {
					parent.addClass("is-error");
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						false
					);
				} else {
					parent.removeClass("is-error");
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						true
					);
					var regDueDate = new Date(
						vm.fieldValues.regDueYear,
						vm.fieldValues.regDueMonth - 1,
						vm.fieldValues.regDueDay
					);
					var dateToday = new Date(Date.now());
					dateToday.setHours(0);
					dateToday.setMinutes(0);
					dateToday.setSeconds(0);
					dateToday.setMilliseconds(0);
					var maxRegDate = new Date(Date.now());
					maxRegDate.setFullYear(dateToday.getFullYear() + 1);
					if (regDueDate >= dateToday && regDueDate <= maxRegDate) {
						vm.formSelector.registrationDueDate.$setValidity(
							"maxdate",
							true
						);
					} else
						vm.formSelector.registrationDueDate.$setValidity(
							"maxdate",
							false
						);
				}
			}
		});

		$scope.$on("form-submitted", function (event, args) {
			validateBirthDate();
			validateRegistrationDueDate();
			validatePostCode();
			validateExpiryDate();
		});

		function getYearDiff(fromDate, toDate) {
			//var birthDate = new Date(vm.fieldValues.birthYear, vm.fieldValues.birthMonth - 1, vm.fieldValues.birthDay);
			var ageDifMs = toDate - fromDate.getTime();
			var ageDate = new Date(ageDifMs); // miliseconds
			return Math.abs(ageDate.getUTCFullYear() - 1970);
		}

		function validateBirthDate() {
			if (vm.sectionName != "registeredOwnerCtp") return;
			var dateHasPartialValue = false;
			if (
				!isUndefinedOrNull(vm.fieldValues.birthDay) ||
				!isUndefinedOrNull(vm.fieldValues.birthMonth) ||
				!isUndefinedOrNull(vm.fieldValues.birthYear)
			) {
				dateHasPartialValue = true;
			}

			if (
				isUndefinedOrNull(vm.fieldValues.birthDay) ||
				isUndefinedOrNull(vm.fieldValues.birthMonth) ||
				isUndefinedOrNull(vm.fieldValues.birthYear)
			) {
				vm.formSelector.birthDate.$setValidity("age", true);
				vm.fieldValues.birthDate = "";
				if (dateHasPartialValue) {
					vm.formSelector.birthDate.$setValidity("required", true);
					vm.formSelector.birthDate.$setValidity("date", false);
				} else {
					vm.formSelector.birthDate.$setValidity("required", false);
					vm.formSelector.birthDate.$setValidity("date", true);
				}
				return;
			}

			var birthDate =
				vm.fieldValues.birthDay +
				"/" +
				vm.fieldValues.birthMonth +
				"/" +
				vm.fieldValues.birthYear;
			var date = moment(birthDate, "DDMMYYYY");

			if (date.isValid()) {
				if (vm.fieldValues.birthYear.toString().length == 4) {
					vm.fieldValues.birthDate = birthDate;
					vm.formSelector.birthDate.$setValidity("date", true);
				} else {
					vm.formSelector.birthDate.$setValidity("date", false);
				}
			} else {
				vm.formSelector.birthDate.$setValidity("date", false);
			}
		}

		function validateRegistrationDueDate() {
			if (vm.sectionName != "aboutYourCarCtp") return;
			var dateHasPartialValue = false;
			if (
				!isUndefinedOrNull(vm.fieldValues.regDueDay) ||
				!isUndefinedOrNull(vm.fieldValues.regDueMonth) ||
				!isUndefinedOrNull(vm.fieldValues.regDueYear)
			) {
				dateHasPartialValue = true;
			}

			if (
				isUndefinedOrNull(vm.fieldValues.regDueDay) ||
				isUndefinedOrNull(vm.fieldValues.regDueMonth) ||
				isUndefinedOrNull(vm.fieldValues.regDueYear)
			) {
				vm.fieldValues.registrationDueDate = "";
				if (dateHasPartialValue) {
					vm.formSelector.registrationDueDate.$setValidity(
						"required",
						true
					);
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						false
					);
				} else
					vm.formSelector.registrationDueDate.$setValidity(
						"required",
						false
					);
				return;
			}

			var regDueDate =
				vm.fieldValues.regDueDay +
				"/" +
				vm.fieldValues.regDueMonth +
				"/" +
				vm.fieldValues.regDueYear;
			var date = moment(regDueDate, "DDMMYYYY");

			if (date.isValid()) {
				if (vm.fieldValues.regDueYear.toString().length == 4) {
					vm.fieldValues.registrationDueDate = regDueDate;
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						true
					);
				} else {
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						false
					);
				}
			}
		}

		function validatePostCode() {
			if (vm.sectionName == "registeredOwnerCtp") {
				vm.formSelector.regPostCode.$setValidity("valid", true);
				if (!isUndefinedOrNull(vm.fieldValues.regPostCode)) {
					var postCode = parseInt(vm.fieldValues.regPostCode);
					var postCodeIsValid =
						(postCode >= 4000 && postCode <= 4999) ||
						postCode == 9726;
					if (!postCodeIsValid) {
						vm.formSelector.regPostCode.$setValidity(
							"valid",
							false
						);
					}
				}
			}
		}

		function isDate(value) {
			//format(dd/MM/yyyy)
			var re = /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/;
			var flag = re.test(value);
			return flag;
		}

		function isUndefinedOrNull(arg) {
			if (angular.isUndefined(arg) || arg == null) {
				return true;
			}

			return false;
		}

		vm.confirmSwitch = function () {
			$scope.$emit("confirm-switch");
		};

		vm.backToForm = function () {
			$scope.$emit("show-form-entry");
		};

		function getYearDiff(fromDate, toDate) {
			//var birthDate = new Date(vm.fieldValues.birthYear, vm.fieldValues.birthMonth - 1, vm.fieldValues.birthDay);
			var ageDifMs = toDate - fromDate.getTime();
			var ageDate = new Date(ageDifMs); // miliseconds
			return Math.abs(ageDate.getUTCFullYear() - 1970);
		}

		function validateBirthDate() {
			if (vm.sectionName != "registeredOwnerCtp") return;
			var dateHasPartialValue = false;
			if (
				!isUndefinedOrNull(vm.fieldValues.birthDay) ||
				!isUndefinedOrNull(vm.fieldValues.birthMonth) ||
				!isUndefinedOrNull(vm.fieldValues.birthYear)
			) {
				dateHasPartialValue = true;
			}

			if (
				isUndefinedOrNull(vm.fieldValues.birthDay) ||
				isUndefinedOrNull(vm.fieldValues.birthMonth) ||
				isUndefinedOrNull(vm.fieldValues.birthYear)
			) {
				vm.formSelector.birthDate.$setValidity("age", true);
				vm.fieldValues.birthDate = "";
				if (dateHasPartialValue) {
					vm.formSelector.birthDate.$setValidity("required", true);
					vm.formSelector.birthDate.$setValidity("date", false);
				} else {
					vm.formSelector.birthDate.$setValidity("required", false);
					vm.formSelector.birthDate.$setValidity("date", true);
				}
				return;
			}

			var birthDate =
				vm.fieldValues.birthDay +
				"/" +
				vm.fieldValues.birthMonth +
				"/" +
				vm.fieldValues.birthYear;
			if (isDate(birthDate)) vm.fieldValues.birthDate = birthDate;

			vm.formSelector.birthDate.$setValidity("date", true);
		}

		function validateRegistrationDueDate() {
			if (vm.sectionName != "aboutYourCarCtp") return;
			var dateHasPartialValue = false;
			if (
				!isUndefinedOrNull(vm.fieldValues.regDueDay) ||
				!isUndefinedOrNull(vm.fieldValues.regDueMonth) ||
				!isUndefinedOrNull(vm.fieldValues.regDueYear)
			) {
				dateHasPartialValue = true;
			}

			if (
				isUndefinedOrNull(vm.fieldValues.regDueDay) ||
				isUndefinedOrNull(vm.fieldValues.regDueMonth) ||
				isUndefinedOrNull(vm.fieldValues.regDueYear)
			) {
				vm.fieldValues.registrationDueDate = "";
				if (dateHasPartialValue) {
					vm.formSelector.registrationDueDate.$setValidity(
						"required",
						true
					);
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						false
					);
				} else
					vm.formSelector.registrationDueDate.$setValidity(
						"required",
						false
					);
				return;
			}

			var regDueDate =
				vm.fieldValues.regDueDay +
				"/" +
				vm.fieldValues.regDueMonth +
				"/" +
				vm.fieldValues.regDueYear;
			if (isDate(regDueDate))
				vm.fieldValues.registrationDueDate = regDueDate;
			vm.formSelector.registrationDueDate.$setValidity("date", true);
		}

		function validatePostCode() {
			if (vm.sectionName == "registeredOwnerCtp") {
				vm.formSelector.regPostCode.$setValidity("valid", true);
				if (!isUndefinedOrNull(vm.fieldValues.regPostCode)) {
					var postCode = parseInt(vm.fieldValues.regPostCode);
					var postCodeIsValid =
						(postCode >= 4000 && postCode <= 4999) ||
						postCode == 9726;
					if (!postCodeIsValid) {
						vm.formSelector.regPostCode.$setValidity(
							"valid",
							false
						);
					}
				}
			}
		}

		/*
			When select a product from drop down
			validate product and do Gtm tracking
		*/
		function selectProduct(value) {
			validateProducts(value);
			gtmService.trackProductSelect(value);			
		}		

		/*
		 * Redirect to other payment sites
		 * Param - Product value from drop down list
		 
		vm.payNonQbe = function () {			
			var sessionProt = window.location.protocol;
			var sessionProtHost = window.location.host;
			var sessionProtPath = $window.qbe.fieldLabels && $window.qbe.fieldLabels.nonQbeRedirect ? $window.qbe.fieldLabels.nonQbeRedirect.QBE : '/';               
			var sessionProtURL = sessionProt + "//" + sessionProtHost + sessionProtPath;
			
			window.location.href = sessionProtURL;			
		};
		*/

		/*
		 * Validate Products for Redirect Link
		 * Param - Product value from drop down list
		 */
		function validateProducts(value) {
			var QBEProducts = [
				"CAR",
				"BOAT",
				"CARAVAN",
				"CONTENTS",
				"HOME",
				"LANDLORD",
				"MOTORCYCLE",
			];
			var NonQBEProducts = [
				"CTP - NSW GREEN SLIP",
				"CTP - QLD",
				"TRAVEL",
				"SMALL BUSINESS"
			];
			var redirectLinks = $window.qbe.fieldLabels.nonQbeRedirect;

			if (!isUndefinedOrNull(value)) {
				$scope.$broadcast("broadcast-no-field-errors");
				var productLabel = value.replace(/[^a-z\d\s]+/gi, "");
				vm.productCode = value;
				vm.otherWaysLabel = productLabel;
				value = value.toUpperCase();

				if (containsInArray(QBEProducts, value)) {
					vm.productValue = "QBEProducts";
				} else if (containsInArray(NonQBEProducts, value)) {
					vm.productValue = "NonQBEProducts";
					switch (value) {
						case "CTP - NSW GREEN SLIP":
							vm.nonQbeLink = redirectLinks.NSW;
							break;

						case "CTP - QLD":
							vm.nonQbeLink = redirectLinks.QLD;
							break;

						case "TRAVEL":
							vm.nonQbeLink = redirectLinks.Travel;
							break;
						case "SMALL BUSINESS":
							vm.nonQbeLink = redirectLinks.SmallBusiness;
							break;
					}
				} else if (containsInArray(MotorProducts, value)) {
					vm.productValue = "MotorProducts";
				}

				vm.showPaymentSection = false;

				$scope.$emit("pay-now-button", vm.productValue);
			}
		}

		function containsInArray(arrayList, value) {
			return arrayList.indexOf(value) > -1;
		}

		//PAYMENTS FORM END

		function isDate(value) {
			//format(dd/MM/yyyy)
			var re = /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/;
			var flag = re.test(value);
			return flag;
		}

		function isUndefinedOrNull(arg) {
			if (angular.isUndefined(arg) || arg == null) {
				return true;
			}

			return false;
		}

		vm.confirmSwitch = function () {
			$scope.$emit("confirm-switch");
		};

		vm.backToForm = function () {
			$scope.$emit("show-form-entry");
		};

		vm.back = function () {
			var backState = dynamicRouter.back();
			if (backState) $state.go(backState);

			return false;
		};

		function validateBuildingSumInsured(event) {
			vm.showContentsSumInsuredInLowerRange = false;

			var key = $window.event ? event.keyCode : event.which;
			if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		}

		function getBuildingEstimate() {
			return Math.floor(
				vm.quoteModel.cordelInfo.spotValue
			).toLocaleString("en-US");
		}

		function getBuildingMaximum() {
			return vm.quoteModel.maxSumInsured.toLocaleString("en-US");
		}

		function getBuildingMinimum() {
			return vm.quoteModel.minSumInsured.toLocaleString("en-US");
		}

		function toggleContentsSumInsuredInLowerRange() {
			vm.showContentsSumInsuredInLowerRange =
				vm.quoteModel.isSumInsuredInLowerRange(
					vm.fieldValues.buildingSumInsured
				) && vm.fieldValues.isEstimatedRebuildCost == "no";
		}

		function toggleYourContentsSumInsuredInLowerRange() {
			vm.showYourContentsSumInsuredInLowerRange =
				vm.quoteModel.isSumInsuredInLowerRange(
					vm.fieldValues.yourBuildingSumInsured
				) && vm.fieldValues.isYourEstimatedRebuildCost == "no";
		}

		function checkBuildingSumInsured() {
			if (!isUndefinedOrNull(vm.fieldValues.buildingSumInsured)) {
				vm.fieldValues.isEstimatedRebuildCost = "no";
			}
		}
		//dd-3747 - function to assign building sum insured if estimated is selected
		function getEstimateRebuild() {
			if (vm.fieldValues.isEstimatedRebuildCost == "yes") {
				vm.fieldValues.buildingSumInsured = Math.floor(
					vm.quoteModel.cordelInfo.spotValue
				);
			}
			if (vm.fieldValues.isYourEstimatedRebuildCost == "yes") {
				vm.fieldValues.yourBuildingSumInsured = Math.floor(
					vm.quoteModel.cordelInfo.spotValue
				);
			}
		}

		vm.dutyClicked = function ($event) {
			var $target = $($event.currentTarget);
			if ($target.hasClass("is-expanded")) {
				$target.parent().removeClass("expanded");
			} else $target.parent().addClass("expanded");
		};

		/*
		 * Function to limit numbers on text input
		 * Param - key event
		 */

		$scope.validNumber = function (event) {
			var key = $window.event ? event.keyCode : event.which;
			if (key === 8) {
				return true;
			} else if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		};

		$scope.validPhoneNum = function (event, element) {
			var futureValue = event.delegateTarget.value;
			var key = $window.event ? event.keyCode : event.which;

			if (key === 43) {
				return true;
			} else if (key === 8) {
				return true;
			} else if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		};

		function validateBuildingSumInsured(event) {
			vm.showContentsSumInsuredInLowerRange = false;

			var key = $window.event ? event.keyCode : event.which;
			if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		}

		$scope.$watch("vm.fieldValues.expiryMonth", function (value) {
			validateExpiryDate();
		});

		$scope.$watch("vm.fieldValues.expiryYear", function (value) {
			validateExpiryDate();
		});

		function validateExpiryDate() {
			if (
				isUndefinedOrNull(vm.fieldValues.expiryMonth) ||
				isUndefinedOrNull(vm.fieldValues.expiryYear)
			) {
				// if(!isUndefinedOrNull(vm.formSelector) && !isUndefinedOrNull(vm.formSelector.expiryDate)){
				// vm.formSelector.expiryDate.$setValidity('required', false);
				// }
				vm.fieldValues.expiryDate = "";
				return;
			}

			var expiryDate =
				vm.fieldValues.expiryMonth + "/" + vm.fieldValues.expiryYear;
			var date = moment(expiryDate, "MMYY");
			// vm.formSelector.expiryDate.$setValidity('required', true);
			if (date.isValid()) {
				vm.fieldValues.expiryDate = expiryDate;
				// vm.formSelector.expiryDate.$setValidity('invalidDate', true);
			}
		}

		function getBuildingEstimate() {
			return Math.floor(
				vm.quoteModel.cordelInfo.spotValue
			).toLocaleString("en-US");
		}

		function getBuildingMaximum() {
			return vm.quoteModel.maxSumInsured.toLocaleString("en-US");
		}

		function getBuildingMinimum() {
			return vm.quoteModel.minSumInsured.toLocaleString("en-US");
		}

		function toggleContentsSumInsuredInLowerRange() {
			vm.showContentsSumInsuredInLowerRange =
				vm.quoteModel.isSumInsuredInLowerRange(
					vm.fieldValues.buildingSumInsured
				) && vm.fieldValues.isEstimatedRebuildCost == "no";
		}

		$scope.validPhoneNum = function (event, element) {
			var futureValue = event.delegateTarget.value;
			var key = $window.event ? event.keyCode : event.which;

			if (key === 43) {
				return true;
			} else if (key === 8) {
				return true;
			} else if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		};

		function validateBuildingSumInsured(event) {
			vm.showContentsSumInsuredInLowerRange = false;

			var key = $window.event ? event.keyCode : event.which;
			if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		}

		function getBuildingEstimate() {
			return Math.floor(
				vm.quoteModel.cordelInfo.spotValue
			).toLocaleString("en-US");
		}

		function getBuildingMaximum() {
			return vm.quoteModel.maxSumInsured.toLocaleString("en-US");
		}

		function getBuildingMinimum() {
			return vm.quoteModel.minSumInsured.toLocaleString("en-US");
		}

		function toggleContentsSumInsuredInLowerRange() {
			vm.showContentsSumInsuredInLowerRange =
				vm.quoteModel.isSumInsuredInLowerRange(
					vm.fieldValues.buildingSumInsured
				) && vm.fieldValues.isEstimatedRebuildCost == "no";
		}
	}

	angular.module("qbePortal").directive("qbFormSection", [
		"hierarchyDecorator",
		function (hierarchyDecorator) {
			return {
				restrict: "EA",
				controller: FormSection,
				controllerAs: "vm",
				transclude: true,
				scope: {
					init: "&",
					register: "&?",
					name: "@",
					/**
					 * @formData : Used on the highest level of form sections to bind values to the controller.
					 */
					formData: "<",
					/**
					 * @setHierarchy:  Callback used by hierarchy decorator to set the current hierarchy of a form section
					 */
					setHierarchy: "&",
					/**
					 * @fieldValues: Binding to set the field values for a section.
					 */
					fieldValues: "<?",
					/**
					 * @formSelector : Selector pointing to ng-form of the current form section.  Used for maintaining native angular form validation.
					 */
					formSelector: "<?",
					/**
					 * @aggregatedListName : optional value provided for aggregated lists to bind their values to an array with the given name
					 */
					aggregatedListName: "@?",
				},
				link: function (scope, element, attrs, ctrl, transclude) {
					scope.element = element;
					scope.getHTMLId = function () {
						return scope.element.attr("id");
					};

					if (scope.setHierarchy !== undefined)
						hierarchyDecorator.attach(scope, {
							element: element,
							name: scope.name,
							$id: scope.$id,
						});

					transclude(scope, function (clone) {
						element.append(clone);
					});
				},
			};
		},
	]);
})();
